var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4299_334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.83137 7.99991C9.83492 9.20108 9.36161 10.3546 8.51538 11.207C7.66916 12.0595 6.5192 12.5413 5.31804 12.5466C4.11688 12.5413 2.96692 12.0595 2.1207 11.207C1.27447 10.3546 0.801163 9.20108 0.804707 7.99991C0.801163 6.79875 1.27447 5.64528 2.1207 4.7928C2.96692 3.94033 4.11688 3.45854 5.31804 3.45325C6.5192 3.45854 7.66916 3.94033 8.51538 4.7928C9.36161 5.64528 9.83492 6.79875 9.83137 7.99991ZM14.778 7.99991C14.778 10.3599 13.7714 12.2799 12.5247 12.2799C11.278 12.2799 10.2647 10.3599 10.2647 7.99991C10.2647 5.63991 11.278 3.71991 12.5247 3.71991C13.7714 3.71991 14.778 5.63991 14.778 7.99991ZM16.8047 7.99991C16.8047 10.1132 16.4514 11.8332 16.0114 11.8332C15.5714 11.8332 15.218 10.1132 15.218 7.99991C15.218 5.88658 15.5714 4.16658 16.0114 4.16658C16.4514 4.16658 16.8047 5.88658 16.8047 7.99991Z",
    fill: "#B7B7B7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4299_334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.804688)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/Medium.963e900a52cc2267ef51b74cb2115d40.svg";
export { ForwardRef as ReactComponent };